import { linkOptions } from '@tanstack/react-router';
import { PROCESSED_NOTIFICATION_KINDS, type ProcessedNotificationKind } from 'cpool-constants';

import { LEAD_DETAILS_OVERLAYS } from '~/features/leadDetails/constants/overlays';

const NOTIFICATION_LINK_OPTIONS = {
    [PROCESSED_NOTIFICATION_KINDS.RESUBMISSION]: (leadId: string) =>
        linkOptions({ params: { leadId }, to: '/leads/details/$leadId' }),
    [PROCESSED_NOTIFICATION_KINDS.DOCUMENT]: (leadId: string) =>
        linkOptions({ params: { leadId }, to: '/leads/details/$leadId/document-center' }),
    [PROCESSED_NOTIFICATION_KINDS.ASSIGNED_USER_ADDED]: (leadId: string) =>
        linkOptions({ params: { leadId }, to: '/leads/details/$leadId' }),
    [PROCESSED_NOTIFICATION_KINDS.ACTIVE_USER_SET]: (leadId: string) =>
        linkOptions({ params: { leadId }, to: '/leads/details/$leadId' }),
    // consorsNotes is scoped to offer-management - on any other path it gets normalized away
    [PROCESSED_NOTIFICATION_KINDS.BANK_REPORT]: (leadId: string) =>
        linkOptions({
            params: { leadId },
            search: { [LEAD_DETAILS_OVERLAYS.CONSORS_NOTES]: true },
            to: '/leads/details/$leadId/offer-management',
        }),
} satisfies Record<ProcessedNotificationKind, (_leadId: string) => unknown>;

export function getNotificationLinkOptions(kind: ProcessedNotificationKind, leadId: string) {
    return NOTIFICATION_LINK_OPTIONS[kind](leadId);
}

export type NotificationLinkOptions = ReturnType<typeof getNotificationLinkOptions>;
